import React, { useState, useEffect } from "react";

/**
 * PC_Ac_04 getAnnouncementData gets imported from api.js file
 */
import { getAnnouncemetData } from "../service/api";
import { useNavigate } from 'react-router-dom';
import '../components/css/Dashboard-styles.css'
import { getS3 } from '../utils/Download.js';


const EmployeeAnnouncement = () => {

    const navigate = useNavigate();


    /**
 * PC_Ac_02
 * The data state variable is created for storing the response data
 */

    const [data, setData] = useState([])
    const [imageUrls, setImageUrls] = useState({}); 
    useEffect(() => {

        fetchApi()

    }, [])
    useEffect(() => {
        // Fetch image URLs asynchronously when data changes
        (async () => {
            const urlPromises = data.map(async datum => {
                const url = datum.attachment ? await getS3(datum.attachment) : '/default-image-path';
                return [datum.id, url];
            });
            const urls = await Promise.all(urlPromises);
            setImageUrls(Object.fromEntries(urls));
        })();
    }, [data]); 

    /**
* PC_Ac_06
* The fetchApi function in the useEffects gets invoked which inturn call the getAnnouncemetData() function with respective parameters
*/

    const fetchApi = async () => {

        const resp = await getAnnouncemetData();

        if (resp?.data?.ResponseData.length) setData(resp.data.ResponseData)

    }


    /**
 * PC_Ac_10
 * The response data gets stored in the data variable and mapped to the respective divs
 */

    const empAnnouncementBody = () => {

        try {

            return (
                (data.length > 0) ?
                    data.map((datum, i) => {


                        let nameVar

                        if (datum.description.length > 15) {

                            nameVar = datum.description.substring(0, 15)
                            nameVar = nameVar + "..."
                        }
                        else {

                            nameVar = datum.description
                        }

                        return (

                            <div className={`carousel-item dashboard-custom-announcements-height-tm position-relative  ${i == 0 ? 'active' : ""}`}>
                                <h5 className="tt-bold font-15 p-3">Announcements</h5>
                                <div className="d-flex">
                                    <div className="announcement-content w-50 ps-5" >
                                        <h5 className="regular-text font-22 pt-3 ps-3">{datum.title}</h5>
                                        <h5 className="tt-regular-text font-22 ps-3  mb-0">{nameVar}</h5>
                                        <a onClick={() => { navigate('/announcements', { state: { id: datum.id } }) }} className="ps-3 pt-0 regular-text font-14 text-decoration-none link-secondary" style={{ cursor: "pointer !important" }}>Read more</a>
                                    </div>
                                    <div className="end-0 position-absolute dashboard-announc-img-content d-flex justify-content-end  pe-5">
                                    <img src={imageUrls[datum.id] || '/default-image-path'} className="dashboard-announcement-image-tm" />
                                    </div>
                                </div>
                            </div>
                        )
                    }) : <>
                        <div className={`carousel-item dashboard-custom-announcements-height-tm position-relative active`}>
                            <h5 className="tt-bold font-15 p-3">Announcements</h5>
                            <div className="d-flex">
                            </div>
                        </div>
                    </>
            )
        }
        catch (err) {


        }
    }

    return (

        <div id="carouselAnnoucement" className="carousel slide carousel-fade custom-carousel-fade" data-bs-ride="carousel">
            <div className="carousel-indicators custom-carousel-indicators">
                {
                    data.length > 1 ? data.map((datum, i) => {
                        return (
                            <button type="button" data-bs-target="#carouselAnnoucement" data-bs-slide-to={i} className={(i == 0) ? `active` : ""} aria-label={`Slide ${i + 1}`} />
                        )
                    }) : <></>
                }
                {/* <button type="button" data-bs-target="#carouselAnnoucement" data-bs-slide-to={0} className="active" aria-current="true" aria-label="Slide 1" />
                <button type="button" data-bs-target="#carouselAnnoucement" data-bs-slide-to={1} aria-label="Slide 2" />
                <button type="button" data-bs-target="#carouselAnnoucement" data-bs-slide-to={2} aria-label="Slide 3" /> */}
            </div>
            <div className="carousel-inner dashboard-custom-carousel-inner">

                {empAnnouncementBody()}

            </div>
            {
                data.length > 1 ? <>
                    <button className="carousel-control-prev dashboard-custom-announcements-height-tm" type="button" data-bs-target="#carouselAnnoucement" data-bs-slide="prev">
                        <span className="carousel-control-prev-icon" aria-hidden="true" />
                        <span className="visually-hidden">Previous</span>
                    </button>
                    <button className="carousel-control-next dashboard-custom-announcements-height-tm" type="button" data-bs-target="#carouselAnnoucement" data-bs-slide="next">
                        <span className="carousel-control-next-icon" aria-hidden="true" />
                        <span className="visually-hidden">Next</span>
                    </button></> : <></>
            }


        </div>
    )
}


export default EmployeeAnnouncement